import React, { useState } from 'react';
import { NavDropdown } from 'react-bootstrap'
import Label from "components/general/Label"
import { useUrlFriendlyToParameters, useNavigateTo } from 'helpers/urlFriendly';
import { TYPE_DATA, isParalympic, sortDataByField, splitArrayIntoFourColumns } from "helpers/utils";


//Sport Pictos Sprites SpritePictosSmall for the old ones and SpritePictosBig for the new big ones (Paris2024) 

//import SpritesPictos from "styles/OG2024/images/SpritePictosSmall.svg";
import SpritesPictos from "styles/OG2024/images/SpritePictosBig.svg";
//import SpritesPictos_Para from "styles/PG2024/images/SpritePictosSmall.svg";
import SpritesPictos_Para from "styles/PG2024/images/SpritePictosBig.svg";


export default function SelectorDisciplineMenu({ data, page }) {
    let params = useUrlFriendlyToParameters()
    const [paramsUrl, setParamsUrl] = useState({});
    const [shouldNavigate, setShouldNavigate] = useState(false);
    useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, page)

    //copy parameters URL to change 
    let paramsURL = { ...params }
    //Change object if make changes over params make changes in componets related   
    if (paramsURL['mirs_competition'] === undefined) {
        paramsURL['mirs_competition'] = process.env.REACT_APP_DEFAULT_COMPETITION
    }

    if (paramsURL['mirs_language'] === undefined) {
        paramsURL['mirs_language'] = process.env.REACT_APP_DEFAULT_LANGUAGE
    }

    paramsURL["mirs_event"] = "";
    paramsURL["mirs_date"] = "";

    const sports = data?.filter(item => item?.isSport && item?.scheduled)

    if (sports?.some(disc => disc?.descriptionOrder && disc?.descriptionOrder !== 0)) {
        sortDataByField(sports, 'descriptionOrder', true, TYPE_DATA.NUMBER)
    } else {
        sortDataByField(sports, 'description', true, TYPE_DATA.STRING)
    }
    const options = sports?.map((item, index) => {
        return (
            <NavDropdown.Item key={"Selector-Discipline-" + item.code} eventKey={item.code} >
                <ItemDiscipline code={item.code} description={item.description} />
            </NavDropdown.Item>
        )
    })

    //Go to schedule 
    const handleOnChange = (key) => {
        paramsURL["mirs_discipline"] = key
        setParamsUrl(paramsURL);
        setShouldNavigate(true);
    };


    let allData

    if (page !== 'records') {
        allData = <div className="title">
            <Label data={'LabelDisciplines'} />
        </div>
    }

    const arrayOfColumns = splitArrayIntoFourColumns(options);

    return (
        <NavDropdown onSelect={handleOnChange} title={<Label data={'LabelDisciplines'} />} id="selectorDiscipline1" className={"selector-disciplne dropdownWithGrid"} >
            {allData}
            <div className="menu">
                {arrayOfColumns}
            </div>
            <hr />
        </NavDropdown>
    );
};

export const ItemDiscipline = (props) => {
    const { mirs_competition } = useUrlFriendlyToParameters()
    let competition = mirs_competition;
    const [showImage, setShowImage] = useState(true);
    const hideImg = (event) => {
        // this.setState({ showImg: false });
        setShowImage(false);
    };
    let Sprites
    if (isParalympic(mirs_competition)) {
        Sprites = SpritesPictos_Para;
    } else {
        Sprites = SpritesPictos;
    }


    return (
        <div className="itemDiscipline justify-content-left">
            <div className="sport-icon">
                {showImage ? (
                    <>
                        <svg role="img" className='sport-icon' aria-hidden="true" focusable="false"> <title>{props.code}</title><use xlinkHref={`${Sprites}#${props.code}`} /></svg>
                        {/*       <span className={props.code} alt={props.description}></span>*/}
                    </>
                ) : (
                    props.code
                )}
            </div>
            {props.description}
            {/*{props.code && <> - {props.code}</>}*/}
        </div>
    )
};